'use client'

import { initViewportHeightListener } from '@/lib/viewport-height'
import { useEffect } from 'react'

/**
 * 视口高度提供者组件
 * 负责初始化视口高度监听，确保CSS变量 --vh 始终反映真实的视口高度
 */
export function ViewportHeightProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // 初始化视口高度监听
    const cleanup = initViewportHeightListener()

    // 组件卸载时清理监听器
    return cleanup
  }, [])

  return <>{children}</>
}
